import { useEffect, useRef, useState } from "react";
import { parseLocalDateTime } from "../utils/parseLocalDateTime";
import { useAppContext } from "../../../2_ksbHub/context/appContext";
import { useSondertagContext } from "../context/sondertagContext";

export default function useSonderEventLock() {
  const { isAStudent, isATeacher } = useAppContext();
  const { selectedSonderEvent, isASondertageEventAdmin } =
    useSondertagContext();

  const [now, setNow] = useState(new Date());
  const [showUnlockedToast, setShowUnlockedToast] = useState(false);

  const unlockTime = parseLocalDateTime(selectedSonderEvent?.unlockTime);

  /**
   * ✅ update time when sondertag changes
   */
  useEffect(() => {
    setNow(new Date());
  }, [selectedSonderEvent?.id, selectedSonderEvent?.unlockTime]);

  /**
   * ✅ schedule unlock (ONLY based on time)
   */
  useEffect(() => {
    if (!unlockTime) return;

    const current = new Date();
    if (current >= unlockTime) return;

    const timeout = setTimeout(() => {
      setNow(new Date());
    }, unlockTime - current);

    return () => clearTimeout(timeout);
  }, [unlockTime]);

  /**
   * ✅ role-based lock decision
   */
  const shouldBeLocked =
    (isAStudent && selectedSonderEvent?.lockForStudents) ||
    (isATeacher &&
      selectedSonderEvent?.lockForTeachers &&
      !isASondertageEventAdmin);

  /**
   * ✅ final lock state
   */
  const showLockScreen = shouldBeLocked && unlockTime && now < unlockTime;

  /**
   * ✅ toast (locked → unlocked)
   */
  const prevLockedRef = useRef(showLockScreen);

  useEffect(() => {
    if (prevLockedRef.current && !showLockScreen) {
      setShowUnlockedToast(true);
    }
    prevLockedRef.current = showLockScreen;
  }, [showLockScreen]);

  return {
    showLockScreen,
    unlockTime,
    showUnlockedToast,
    setShowUnlockedToast,
  };
}
